import * as React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { ChevronDownIcon } from '@/utils/iconSVG';

import { FieldWrapperPassThroughProps } from './FieldWrapper';
import { stylesSelect, stylesSelectHelperText } from './SelectField.styles';

export type Option = {
  optLabel: React.ReactNode;
  optValue: string | number | string[];
  optDisabled?: boolean;
  disabled?: boolean;
};

type SelectFieldProps = FieldWrapperPassThroughProps & {
  value?: string;
  options: Option[];
  className?: string;
  disabled?: boolean;
  defaultValue?: string;
  placeholder?: string;
  registration?: Partial<UseFormRegisterReturn>;
  onChange?: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
};

export function SelectField(props: SelectFieldProps) {
  const {
    id,
    label,
    isRequired,
    options,
    error,
    value,
    registration,
    className = '',
    defaultValue = '',
    placeholder = '',
    disabled = false,
    onChange,
  } = props;

  return (
    <>
      <InputLabel id={`${id}-label`}>
        {label}
        {isRequired ? '*' : ''}
      </InputLabel>
      <FormControl fullWidth disabled={disabled}>
        <Select
          labelId={`${id}-label`}
          id={id}
          error={!!error}
          placeholder={placeholder}
          className={className}
          defaultValue={defaultValue}
          displayEmpty
          size='small'
          fullWidth
          IconComponent={ChevronDownIcon}
          sx={stylesSelect}
          value={value}
          onChange={onChange}
          {...registration}
        >
          {options.map(({ optLabel, optValue, optDisabled }) => (
            <MenuItem key={optValue?.toString()} value={optValue} disabled={optDisabled || false}>
              {optLabel}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText sx={stylesSelectHelperText}>{error?.message}</FormHelperText>
      </FormControl>
    </>
  );
}
